import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import './problems-solutions.css';

const ProblemsSolutions = () => {
    const { t } = useTranslation();
    const [activeIndex, setActiveIndex] = useState(0);
    const [isMobile, setIsMobile] = useState(false);
    const [isUserActive, setIsUserActive] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Auto-rotate on desktop with longer intervals and pause when user is active
    useEffect(() => {
        if (!isMobile && !isUserActive) {
            const interval = setInterval(() => {
                setActiveIndex((prev) => (prev + 1) % 3);
            }, 6000); // Increased from 4000ms to 6000ms

            return () => clearInterval(interval);
        }
    }, [isMobile, isUserActive]);

    // Reset user activity after a delay
    useEffect(() => {
        if (isUserActive) {
            const timeout = setTimeout(() => {
                setIsUserActive(false);
            }, 10000); // Resume auto-rotation after 10 seconds of inactivity

            return () => clearTimeout(timeout);
        }
    }, [isUserActive, activeIndex]);

    const handleUserNavigation = (index) => {
        setActiveIndex(index);
        setIsUserActive(true);
    };

    const problemSolutions = [
        {
            id: 1,
            problem: {
                title: t("home_home-challenges-mvp"),
                text: t("home_home-challenges-mvp-text"),
                icon: "⚡"
            },
            solution: {
                title: t("home_home-services-service-mvp"),
                text: t("home_home-services-service-mvp-text"),
                icon: "/rocket.svg"
            }
        },
        {
            id: 2,
            problem: {
                title: t("home_home-challenges-ressources"),
                text: t("home_home-challenges-ressources-text"),
                icon: "💰"
            },
            solution: {
                title: t("home_home-services-service-growth"),
                text: t("home_home-services-service-growth-text"),
                icon: "/scale_up.svg"
            }
        },
        {
            id: 3,
            problem: {
                title: t("home_home-challenges-quality"),
                text: t("home_home-challenges-quality-text"),
                icon: "⚠️"
            },
            solution: {
                title: t("home_home-services-service-devops"),
                text: t("home_home-services-service-devops-text"),
                icon: "/gear.svg"
            }
        }
    ];

    if (isMobile) {
        return (
            <div className="problems-solutions-mobile">
                <div className="mobile-cards-container">
                    {problemSolutions.map((item, index) => (
                        <div key={item.id} className="mobile-problem-solution-card">
                            <div className="mobile-problem">
                                <div className="mobile-card-header">
                                    <span className="mobile-card-label">Challenge</span>
                                </div>
                                <h3 className="mobile-card-title">{item.problem.title}</h3>
                                <p className="mobile-card-text">{item.problem.text}</p>
                            </div>

                            <div className="mobile-arrow-container">
                                <div className="mobile-arrow">
                                    <svg viewBox="0 0 24 24" className="arrow-icon">
                                        <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
                                    </svg>
                                </div>
                            </div>

                            <div className="mobile-solution">
                                <div className="mobile-card-header">
                                    <img src={item.solution.icon} alt="" className="mobile-solution-icon" />
                                    <span className="mobile-card-label solution-label">Solution</span>
                                </div>
                                <h3 className="mobile-card-title">{item.solution.title}</h3>
                                <p className="mobile-card-text">{item.solution.text}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    return (
        <div className="problems-solutions-desktop">
            <div className="desktop-navigation">
                {problemSolutions.map((item, index) => (
                    <button
                        key={item.id}
                        className={`nav-button ${activeIndex === index ? 'active' : ''}`}
                        onClick={() => handleUserNavigation(index)}
                    >
                        <span className="nav-title">{item.problem.title}</span>
                    </button>
                ))}
            </div>

            <div className="desktop-content">
                <div className="problem-section">
                    <div className="section-header">
                        <h3 className="section-title">{t("home_home-challenges-the-challenge")}</h3>
                        <div className="section-divider"></div>
                    </div>
                    <div className="problem-card active">
                        <h4 className="card-title">{problemSolutions[activeIndex].problem.title}</h4>
                        <p className="card-description">{problemSolutions[activeIndex].problem.text}</p>
                    </div>
                </div>

                <div className="connection-flow">
                    <div className="flow-line">
                        <div className="flow-dots">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                    <div className="transform-arrow">
                        <svg viewBox="0 0 24 24" className="transform-icon">
                            <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
                        </svg>
                    </div>
                </div>

                <div className="solution-section">
                    <div className="section-header">
                        <h3 className="section-title">{t("home_home-challenges-the-solution")}</h3>
                        <div className="section-divider"></div>
                    </div>
                    <div className="solution-card active">
                        <h4 className="card-title">{problemSolutions[activeIndex].solution.title}</h4>
                        <p className="card-description">{problemSolutions[activeIndex].solution.text}</p>
                    </div>
                </div>
            </div>

            <div className="progress-indicator">
                {problemSolutions.map((_, index) => (
                    <div
                        key={index}
                        className={`progress-dot ${activeIndex === index ? 'active' : ''}`}
                        onClick={() => handleUserNavigation(index)}
                    ></div>
                ))}
            </div>
        </div>
    );
};

export default ProblemsSolutions;
